<template>
  <div
    v-if="updateExists"
    class="tw-bg-white tw-fixed tw-inset-0 tw-w-full tw-z-30 tw-flex tw-items-center"
  >
    <div class="tw-m-auto tw-text-center tw-max-w-lg">
      <div class="tw-text-4xl tw-font-semibold tw-leading-tight tw-mb-4">
        Nomad Soulmates has been updated
      </div>
      <button
        class="btn-squared-rounded-blue"
        @click="refreshApp"
      >
        <i class="fas fa-redo-alt" /> Click to Update!
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },

  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },

  methods: {
    showRefreshUI(e) {
      // Display a button inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.updateExists = true;
    },

    refreshApp() {
      // Handle a user tap on the update app button.
      this.updateExists = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
  },
};
</script>
